<div class="mt-wrapper mat-elevation-z8 ccorbit-mat-table col-settings-wrapper" [style.height]="alto">

  <div class="floating-col-panel" (mouseleave)="contraerColPanel()" [ngClass]="{'expanded': colPanelOpen}">
    <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
      <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
    </div>
    <div class="col-panel-content">
      <h6 class="col-panel-title mb-2">Columnas</h6>
      <div class="col-panel-option" *ngFor="let col of columnas[pestana]">
        <mat-checkbox [checked]="col.visible" (change)="toggleColumna(col)" [color]="'primary'">{{col.nombre}}</mat-checkbox>
      </div>
    </div>
  </div>

  <div class="mt-scroll">

    <!-- ───────────── Operaciones: posiciones + pendientes ───────────── -->
    <table class="mt-table tableStyle table-striped" *ngIf="pestana === 'operaciones'">
      <thead>
        <tr>
          <th *ngFor="let col of visibles.operaciones" class="sticky-header" [class.txt]="col.txt"
            [class.ordenable]="col.pos || col.orden" (click)="ordenarPor(col)">{{col.nombre}} {{flechaOrden(col)}}</th>
          <th class="sticky-header col-x"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pos of posiciones; trackBy: trackPos" (click)="seleccionar(pos)"
          (contextmenu)="seleccionar(pos)" [cdkContextMenuTriggerFor]="menuPosicion"
          [class.selected]="pos === filaSeleccionada">
          <ng-container *ngFor="let col of visibles.operaciones" [ngSwitch]="col.id">
            <td *ngSwitchCase="'simbolo'" class="txt"><mat-icon class="fila-icon">description</mat-icon>{{pos.nombreCompania}}{{pos.secType === 'CFD' ? ' CFD' : ''}}</td>
            <td *ngSwitchCase="'id'" class="txt">{{pos.isooper}} <span *ngIf="bajistaDe(pos) !== null" class="sentido" [class.bajista]="bajistaDe(pos)"
                [matTooltip]="sentido(pos)">{{bajistaDe(pos) ? '↓' : '↑'}}</span>
                <span *ngIf="salidaPendiente(pos) as sp" class="salida-pendiente"
                  matTooltip="El modelo ya dio la salida pero no se envió al broker ({{ sp.estadoEnvio }}). La posición sigue abierta.">Salida pendiente</span></td>
            <td *ngSwitchCase="'ticket'" class="txt">{{ticket(pos)}}</td>
            <td *ngSwitchCase="'fecha'" class="txt">{{fechaPosicion(pos) || (pos.fechaOperacion | smartDate)}}</td>
            <td *ngSwitchCase="'tipo'" class="txt">{{pos.bajista ? 'sell' : 'buy'}}</td>
            <td *ngSwitchCase="'volumen'">{{pos.cantidadacciones}}</td>
            <td *ngSwitchCase="'precio'">{{precio(pos.precioentradareal, pos)}}</td>
            <td *ngSwitchCase="'sl'" [class.celda-sl]="sl(pos)">
              {{sl(pos)}}<button *ngIf="sl(pos)" class="btn-x btn-x-celda" (click)="cancelarNivel(pos, 'sl', $event)" matTooltip="Cancelar Stop Loss">×</button>
              <span *ngIf="!sl(pos) && nivelCancelado(pos, 'sl') !== null" class="nivel-cancelado"><span class="txt-cancelado">Cancelado</span>{{nivelCancelado(pos, 'sl')}}</span>
            </td>
            <td *ngSwitchCase="'tp'" [class.celda-tp]="tp(pos)">
              {{tp(pos)}}<button *ngIf="tp(pos)" class="btn-x btn-x-celda" (click)="cancelarNivel(pos, 'tp', $event)" matTooltip="Cancelar Take Profit">×</button>
              <span *ngIf="!tp(pos) && nivelCancelado(pos, 'tp') !== null" class="nivel-cancelado"><span class="txt-cancelado">Cancelado</span>{{nivelCancelado(pos, 'tp')}}</span>
            </td>
            <td *ngSwitchCase="'actual'">{{precio(pos.cotizacion, pos)}}</td>
            <td *ngSwitchCase="'beneficio'" [class.numero-positivo]="pos.valorlatente > 0" [class.numero-negativo]="pos.valorlatente < 0">
              {{pos.valorlatente | number:'1.2-2'}}
            </td>
            <td *ngSwitchCase="'origen'" class="txt">{{origenPosicion(pos)}}</td>
          </ng-container>
          <td class="col-x">
            <mat-spinner *ngIf="cerrando.has(pos.isooper); else xPos" diameter="12"></mat-spinner>
            <ng-template #xPos>
              <button class="btn-x" (click)="cerrarPosicion(pos, $event)" matTooltip="Cerrar posición">×</button>
            </ng-template>
          </td>
        </tr>

        <tr *ngFor="let orden of pendientes; trackBy: trackOrden" (click)="seleccionar(orden)"
          (contextmenu)="seleccionar(orden)" [cdkContextMenuTriggerFor]="menuOrden"
          [class.selected]="orden === filaSeleccionada" [class.en-cola]="orden.enCola">
          <ng-container *ngFor="let col of visibles.operaciones" [ngSwitch]="col.id">
            <td *ngSwitchCase="'simbolo'" class="txt"><mat-icon class="fila-icon">schedule</mat-icon>{{orden.ticker}}</td>
            <td *ngSwitchCase="'id'" class="txt">{{orden.companyName}} <span *ngIf="bajistaDe(orden) !== null" class="sentido" [class.bajista]="bajistaDe(orden)"
                [matTooltip]="sentido(orden)">{{bajistaDe(orden) ? '↓' : '↑'}}</span></td>
            <td *ngSwitchCase="'ticket'" class="txt">{{orden.orderId}}</td>
            <td *ngSwitchCase="'fecha'" class="txt">{{orden.fechaRegistro ? formatFechaHora(orden.fechaRegistro) : ''}}</td>
            <td *ngSwitchCase="'tipo'" class="txt">{{tipoOrden(orden)}}</td>
            <td *ngSwitchCase="'volumen'">{{orden.quantity}}</td>
            <td *ngSwitchCase="'precio'">{{precio(orden.price, orden)}}</td>
            <td *ngSwitchCase="'sl'" [class.celda-sl]="slOrden(orden)">{{slOrden(orden)}}</td>
            <td *ngSwitchCase="'tp'" [class.celda-tp]="tpOrden(orden)">{{tpOrden(orden)}}</td>
            <td *ngSwitchCase="'actual'"></td>
            <td *ngSwitchCase="'beneficio'" class="estado">{{orden.status}}</td>
            <td *ngSwitchCase="'origen'" class="txt">{{orden.origen | origenOrden}}</td>
          </ng-container>
          <td class="col-x">
            <button class="btn-x" (click)="cancelarOrden(orden, $event)" matTooltip="Cancelar orden">×</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- ───────────── Historial: una fila por posición (entrada + S/L + T/P + cierre) ───────────── -->
    <table class="mt-table tableStyle table-striped" *ngIf="pestana === 'historial'">
      <thead>
        <tr>
          <th *ngFor="let col of visibles.historial" class="sticky-header ordenable" [class.txt]="col.txt"
            (click)="ordenarPor(col)">{{col.nombre}} {{flechaOrden(col)}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let fila of historial; trackBy: trackHistorial" (click)="seleccionar(fila)"
          (contextmenu)="seleccionar(fila)" [cdkContextMenuTriggerFor]="menuOrden"
          [class.selected]="fila === filaSeleccionada"
          [class.salida-sl]="fila.porSl" [class.salida-tp]="fila.porTp">
          <ng-container *ngFor="let col of visibles.historial" [ngSwitch]="col.id">
            <td *ngSwitchCase="'fecha'" class="txt">{{formatFechaHora(fila.entrada.lastExecutionTime_r || fila.entrada.fechaActualizacion || fila.entrada.fechaRegistro)}}</td>
            <td *ngSwitchCase="'ticket'" class="txt">{{fila.entrada.orderId}}</td>
            <td *ngSwitchCase="'simbolo'" class="txt">{{fila.entrada.ticker}}</td>
            <td *ngSwitchCase="'id'" class="txt">{{fila.entrada.companyName}} <span *ngIf="bajistaDe(fila.entrada) !== null" class="sentido" [class.bajista]="bajistaDe(fila.entrada)"
                [matTooltip]="sentido(fila.entrada)">{{bajistaDe(fila.entrada) ? '↓' : '↑'}}</span></td>
            <td *ngSwitchCase="'tipo'" class="txt">{{tipoOrden(fila.entrada)}}</td>
            <td *ngSwitchCase="'volumen'">{{volumen(fila.entrada)}}</td>
            <td *ngSwitchCase="'precio'">{{precio(precioEjec(fila.entrada), fila.entrada)}}</td>
            <td *ngSwitchCase="'sl'" [class.celda-sl]="slHistorial(fila)">{{slHistorial(fila)}}</td>
            <td *ngSwitchCase="'tp'" [class.celda-tp]="tpHistorial(fila)">{{tpHistorial(fila)}}</td>
            <td *ngSwitchCase="'fechaCierre'" class="txt">{{fila.salida ? formatFechaHora(fila.salida.lastExecutionTime_r || fila.salida.fechaActualizacion || fila.salida.fechaRegistro) : ''}}</td>
            <td *ngSwitchCase="'precioCierre'">{{fila.salida ? precio(precioEjec(fila.salida), fila.entrada) : ''}}</td>
            <td *ngSwitchCase="'estado'" class="txt" [class.numero-positivo]="!historialFallida(fila)"
              [class.cancelled-status]="historialFallida(fila)">{{estadoHistorial(fila)}}</td>
            <td *ngSwitchCase="'origenEntrada'" class="txt">{{fila.entrada.origen | origenOrden}}</td>
            <td *ngSwitchCase="'origenSalida'" class="txt">{{fila.salida ? (fila.salida.origen | origenOrden) : ''}}</td>
          </ng-container>
        </tr>
        <tr *ngIf="!historial.length"><td [attr.colspan]="visibles.historial.length || 1" class="txt vacio">Sin órdenes en el historial</td></tr>
      </tbody>
    </table>
  </div>

  <div class="mt-tabs">
    <button [class.active]="pestana === 'operaciones'" (click)="pestana = 'operaciones'">Operaciones</button>
    <button [class.active]="pestana === 'historial'" (click)="pestana = 'historial'">Historial</button>
  </div>
</div>

<ng-template #menuPosicion>
  <div class="example-menu" cdkMenu [ngClass]="{'dark-theme': isDark, 'light-theme': !isDark}">
    <button class="example-menu-item" (click)="cerrarPosicion(filaSeleccionada)" cdkMenuItem>
      <mat-icon class="menu-icon">close</mat-icon>
      <span>Cerrar posición</span>
    </button>
    <button class="example-menu-item" (click)="accionSlTp('establecerSL')" cdkMenuItem>
      <mat-icon class="menu-icon">shield</mat-icon>
      <span>Establecer Stop Loss</span>
    </button>
    <button class="example-menu-item" (click)="editarNivel(filaSeleccionada, 'sl')" cdkMenuItem>
      <mat-icon class="menu-icon">edit</mat-icon>
      <span>Editar Stop Loss…</span>
    </button>
    <button class="example-menu-item" (click)="accionSlTp('actualizarSL')" cdkMenuItem>
      <mat-icon class="menu-icon">trending_up</mat-icon>
      <span>Actualizar Stop Loss</span>
    </button>
    <button class="example-menu-item" (click)="accionSlTp('cancelarSL')" cdkMenuItem>
      <mat-icon class="menu-icon">remove_moderator</mat-icon>
      <span>Cancelar Stop Loss</span>
    </button>
    <button class="example-menu-item" (click)="accionSlTp('establecerTP')" cdkMenuItem>
      <mat-icon class="menu-icon">flag</mat-icon>
      <span>Establecer Profit</span>
    </button>
    <button class="example-menu-item" (click)="editarNivel(filaSeleccionada, 'tp')" cdkMenuItem>
      <mat-icon class="menu-icon">edit</mat-icon>
      <span>Editar Take Profit…</span>
    </button>
    <button class="example-menu-item" (click)="accionSlTp('cancelarTP')" cdkMenuItem>
      <mat-icon class="menu-icon">outlined_flag</mat-icon>
      <span>Cancelar Profit</span>
    </button>
  </div>
</ng-template>

<!-- Pendientes e Historial: mismo menú que lista-ordenes -->
<ng-template #menuOrden>
  <div class="example-menu" cdkMenu [ngClass]="{'dark-theme': isDark, 'light-theme': !isDark}">
    <button class="example-menu-item" (click)="menuCancelar()" cdkMenuItem>
      <mat-icon class="menu-icon">cancel</mat-icon>
      <span>Cancelar</span>
    </button>
    <button class="example-menu-item" (click)="cancelarTodas()" cdkMenuItem>
      <mat-icon class="menu-icon">cancel</mat-icon>
      <span>Cancelar Todas las ordenes</span>
    </button>
    <button class="example-menu-item" (click)="menuEliminar()" cdkMenuItem>
      <mat-icon class="menu-icon">delete</mat-icon>
      <span>Eliminar</span>
    </button>
    <button class="example-menu-item" (click)="menuEditar()" cdkMenuItem>
      <mat-icon class="menu-icon">edit</mat-icon>
      <span>Editar</span>
    </button>
  </div>
</ng-template>
